import { render, staticRenderFns } from "./LocationServiceGeneralInfo.vue?vue&type=template&id=23602cba"
import script from "./LocationServiceGeneralInfo.vue?vue&type=script&lang=js"
export * from "./LocationServiceGeneralInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports